import React from 'react'
import { storiesOf } from '@storybook/react'

import MostSelected from 'components/MostSelected'

storiesOf('MostSelected', module)
  .add('default', () => (
    <MostSelected />
  ))
  .add('with data', () => (
    <MostSelected
      player={{
        name: 'C. Ronaldo',
        jersey: {
          baseColor: 'FFFFFF',
          jerseyNumber: '7',
          numberColor: '000000',
          sleeveColor: '000000',
        },
      }}
      team={{
        name: 'Juventus',
        jersey: {
          baseColor: 'FFFFFF',
          numberColor: '000000',
          sleeveColor: '000000',
        },
      }}
    />
  ))
